import { render } from "./Wz1Form.vue?vue&type=template&id=0067e9b9&scoped=true"
import script from "./Wz1Form.vue?vue&type=script&lang=js"
export * from "./Wz1Form.vue?vue&type=script&lang=js"

import "./Wz1Form.vue?vue&type=style&index=0&id=0067e9b9&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/wz-case-form-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0067e9b9"]])

export default __exports__